import {Component, Input, Output, SimpleChanges, EventEmitter, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {CommonConstants, ImagePathConstants, RoutesConstants, ImageSizeConstants} from '@coreconstant';

@Component({
    selector: 'app-search-panel',
    imports: [],
    templateUrl: './search-panel.component.html',
    styleUrl: './search-panel.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class SearchPanelComponent {
    @Input() searchKeyword: string = '';
    @Input() searchData: any;
    @Output() closeSearch = new EventEmitter<any>();
    @Output() clearSearch = new EventEmitter<any>();
    totalResultCount: any;
    venuesCount = 0;
    vendorsCount = 0;
    blogsCount = 0;
    venues: any;
    vendors: any;
    blogs: any;
    currentRoute: string = '';
    imageSizeConstants = ImageSizeConstants
    imagePathConstants = ImagePathConstants
    routesConstants = RoutesConstants
    commonConstants = CommonConstants

    constructor(private _router: Router) {
        this.currentRoute = this._router.url.split('?')[0];
        this._router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentRoute = this._router.url.split('?')[0];
            }
        });
    }

    /**
     * Initializes the component and its dependent processes.
     */
    ngOnInit(): void {
    }

    /**
     * Responds to changes in the input properties of the component and updates relevant data accordingly.
     * @param {SimpleChanges} changes - An object containing the changed input properties and their previous/current values.
     */
    ngOnChanges(changes: SimpleChanges) {
        if (changes['searchData']) {
            if (this.currentRoute != '/' + this.routesConstants.SEARCH) {
                this.venuesCount = 0
                this.vendorsCount = 0
                this.blogsCount = 0
                this.totalResultCount = 0

                if (this.searchData) {
                    this.venues = this.searchData?.venues?.records ?? []
                    this.vendors = this.searchData?.vendors?.records ?? []
                    this.blogs = this.searchData?.blogs?.records ?? []

                    if (this.searchData?.venues) {
                        this.venues = this.searchData?.venues?.records
                        this.venuesCount = this.searchData?.venues?.totalCount
                    }

                    if (this.searchData?.vendors) {
                        this.vendors = this.searchData?.vendors?.records
                        this.vendorsCount = this.searchData?.vendors?.totalCount
                    }

                    if (this.searchData?.blogs) {
                        this.blogs = this.searchData?.blogs?.records
                        this.blogsCount = this.searchData?.blogs?.totalCount
                    }
                }

                this.totalResultCount = this.venuesCount + this.vendorsCount + this.blogsCount
            }
        }
    }

    /**
     * Closes the search event by emitting a close signal.
     */
    closeSearchEvent() {
        this.closeSearch.emit(true);
    }

    /**
     * Emits an event to clear the search input or state.
     */
    clearSearchEvent() {
        this.clearSearch.emit(true)
    }

    /**
     * Navigates to the search page with specified query parameters.
     * @param {any} module - The module type to set as a query parameter for the search page.
     */
    goToSearchPage(module: any) {
        this.closeSearchEvent()
        this._router.navigate([this.routesConstants.SEARCH], {queryParams: {type: module, search: this.searchKeyword}});
    }

    /**
     * Navigates to the detail page by constructing the URL using the provided pageUrl and slug.
     * Closes the search event before navigating to the new route.
     * @param {any} pageUrl - The base URL or page path of the detail page to navigate to.
     * @param {any} slug - The unique identifier or slug to be appended to the pageUrl for navigation.
     */
    goToDetailPage(pageUrl: any, slug: any) {
        this.closeSearchEvent()
        this._router.navigate(['/' + pageUrl + '/' + slug]);
    }

    /**
     * Navigates to the blog detail page based on the provided URL parameters.
     * @param {string} pageUrl - The base URL of the blog page.
     * @param {string} categorySlug - The slug associated with the blog's category.
     * @param {string} slug - The unique slug for the specific blog post.
     */
    goToBlogDetailPage(pageUrl: any, categorySlug, slug: any) {
        this.closeSearchEvent()
        this._router.navigate(['/' + pageUrl + '/' + categorySlug + '/' + slug]);
    }
}
